import { getMerchantDataById } from '@nemuru-eng/js-api-client';

import { useCache } from '@/hooks/requests/useCache';

export const useGetMerchantDataById = (merchantId: string) => {
  const { data, loading } = useCache(getMerchantDataById, { merchantId });

  return { merchantData: data, merchantDataLoading: loading };
};
